import { useContext } from 'react';
import { bondSAccIdContext } from './context';

export const useBondSAccId = () => {
  const id = useContext(bondSAccIdContext);
  return id;
};
